export enum ReleasePipelineSource {
    Classic = 0,
    YAML = 1,
    Generic = 2,
}
